<template>
  <div>
    <b-form ref="form" lazy-validation>
      <!-- Input session -->
      <div class="row">
        <div class="col-md-3">
          <b-row class="my-1">
            <b-col>
              <b-form-group class="required-control">
                <label>Tên nhân sự: </label>
                <b-form-input
                  size="sm"
                  v-model="generalInfo.fullName"
                  aria-describedby="input-fullName-live-feedback"
                  placeholder="Nhập tên nhân sự"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div class="col-md-3">
          <b-row class="my-1">
            <b-col>
              <b-form-group class="required-control">
                <label>Mã nhân viên:</label>
                <b-form-input
                  size="sm"
                  placeholder="Nhập mã nhân viên"
                  v-model="generalInfo.code"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div class="col-md-3">
          <b-row class="my-1">
            <b-col>
              <b-form-group>
                <label>Chức vụ:</label>
                <b-form-select
                  required
                  class="select-style"
                  v-model="generalInfo.position.selected"
                  :options="generalInfo.position.options"
                  size="sm"
                  value-field="id"
                  text-field="name"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null"
                      >--Chọn chức vụ--</b-form-select-option
                    >
                  </template></b-form-select
                >
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div class="col-md-3">
          <b-row class="my-1">
            <b-col>
              <b-form-group id="input-group-active">
                <label for="select-status">Trạng thái:</label>
                <b-form-select
                  required
                  class="select-style"
                  v-model="generalInfo.active.selected"
                  :options="generalInfo.active.options"
                  aria-describedby="input-active-live-feedback"
                  size="sm"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- Row 2 -->
      <b-row>
        <b-col md="3">
          <b-form-group>
            <label>SĐT:</label>
            <b-form-input
              style="width: -webkit-fill-available"
              size="sm"
              v-model="generalInfo.phoneNo"
              placeholder="Nhập số điện thoại"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group>
            <label>Email:</label>
            <b-form-input
              size="sm"
              v-model="generalInfo.email"
              placeholder="Nhập email"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group class="mb-0">
            <label> Cửa hàng: </label>
            <Autosuggest
              :model="generalInfo.searchStore"
              :suggestions="generalInfo.filteredOptions"
              :placeholder="'cửa hàng'"
              :limit="10"
              @select="onSelectedStore($event)"
              @change="onInputChange($event)"
              suggestionName="name"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label style="font-weight: 500px">Danh sách cửa hàng:</label>
            <b-input-group>
              <vue-multi-select
                style="margin-bottom: 2rem"
                v-model="generalInfo.listStore"
                :options="generalInfo.listStores"
                placeholder="Chọn cửa hàng"
                option-label="name"
                @input="onChangeListStore()"
              ></vue-multi-select>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <b-form-group>
            <label>Bộ phận:</label>
            <b-form-select
              class="select-style"
              v-model="generalInfo.department.selected"
              :options="generalInfo.department.options"
              size="sm"
              value-field="id"
              text-field="name"
            >
              <template v-slot:first>
                <b-form-select-option :value="null"
                  >-- Chọn bộ phận --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import VueMultiSelect from 'vue-simple-multi-select';

export default {
  props: ['generalInfo'],
  created() {},
  data() {
    return {};
  },
  components: { Autosuggest, VueMultiSelect },
  methods: {
    onSelectedStore(data) {
      this.$emit('onSelectedStore', data);
    },
    onChangeListStore() {
      this.$emit('onChangeListStore');
    },
    onInputChange(data) {
      this.$emit('onInputChange', data);
    },
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="css" scoped>
.center-label label {
  margin-bottom: 0px;
}

.multi-select-wrapper {
  flex: 1 1 auto;
}

.form-group label {
  font-weight: 500;
}
</style>
